import { createFileRoute, redirect } from '@tanstack/react-router'
import LoginPage from '@/pages/login'
import { localizeInternalPath } from '@/shared/i18n/localized-path'

interface LoginSearchParams {
  redirect?: string
}

export const Route = createFileRoute('/$lang/login/')({
  validateSearch: (search: Record<string, unknown>): LoginSearchParams => ({
    redirect:
      typeof search.redirect === 'string' && search.redirect.startsWith('/')
        ? search.redirect
        : undefined,
  }),
  beforeLoad: ({ context, search, params }) => {
    if (context.auth.status === 'AUTHENTICATED') {
      const redirectTo = localizeInternalPath(search.redirect, params.lang)
      if (redirectTo) {
        throw redirect({ href: redirectTo })
      }
      throw redirect({
        to: '/$lang/app',
        params: { lang: params.lang },
      })
    }
  },
  component: LoginPage,
  staticData: { layout: 'public' },
})
